export default __webpack_public_path__ + "static/media/ico-parentProfile.b591e9d2.svg";